export class LeaveType {
  LeaveType;
  EDesc;
  CDesc;
  Color;
  PayLeave;
  DiscPay;
  IsNeedUpload;
  DaysAdv;
  AddBy;
  DateAdd;
  DateModify;
  ModifyBy;
  RecDel;
  constructor() {
    this.LeaveType = "";
    this.EDesc = "";
    this.CDesc = "";
    this.Color = "";
    this.PayLeave = false;
    this.DiscPay = 0;
    this.IsNeedUpload = false;
    this.DaysAdv = 0;
    this.AddBy = "";
    this.DateAdd = "";
    this.DateModify = "";
    this.ModifyBy = "";
    this.RecDel = false
  }
}



// WEBPACK FOOTER //
// ./src/model/LeaveType.js